import { IFoldersWithMaterial } from '@sdk/contracts';
import { Button, Popconfirm } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { NameWrapper, Wrapper } from './FolderName.styles';

import { Icon } from '@/components/Icon';
import { useCourseDetail, useFolderForm, useMutateCourses, useProfile } from '@/store';

type Props = {
  folder: IFoldersWithMaterial;
};

export const FolderName: React.FC<Props> = ({ folder }) => {
  const { name } = folder;
  const { course } = useCourseDetail();
  const { removeFolder } = useMutateCourses();
  const { setData, setIsOpen } = useFolderForm();
  const { t } = useTranslation('CourseTranslations');
  const {
    roleCheck: { isManager }
  } = useProfile();

  const onRemove = () => {
    if (!course) return;
    removeFolder({ courseId: course._id, folderId: folder._id });
  };

  const onClick = (e?: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
    e?.stopPropagation();
    setData(folder);
    setIsOpen(true);
  };

  return (
    <Wrapper>
      <NameWrapper>{name}</NameWrapper>
      <Button size="small" type="link" icon={<Icon i="Edit" />} onClick={onClick} />
      {isManager && (
        <Popconfirm onConfirm={onRemove} title={t('ARE_YOU_SURE_TO_REMOVE_SELECTED')}>
          <Button
            size="small"
            type="link"
            danger
            icon={<Icon i="TrashCan" />}
            onClick={e => e?.stopPropagation()}
          />
        </Popconfirm>
      )}
    </Wrapper>
  );
};
